import HomePage from '@/pages/homepage/HomePage'
import ProductPage from '@/pages/productpage/ProductPage'
import AlliancePage from '@/pages/alliancepage/AlliancePage'
import AboutPage from '@/pages/aboutpage/AboutPage'
import DataSetPage from '@/pages/DataSetPage'
import DetailPage from '@/pages/DetailPage'
import AdminPage from '@/pages/AdminPage'
import InstancePage from '@/pages/InstancePage'
import PoliciesPage from '@/pages/PoliciesPage'
import CasePage from '@/pages/casePage/CasePage'
const routes = [{
  name: 'default',
  path: '*',
  redirect: '/opendata'
},
{
  path: '/opendata',
  name: 'Home',
  component: HomePage,
  meta: {
    title: '中国开放数林指数网'
  }
},
{
  path: '/dataset',
  name: 'DataSet',
  component: DataSetPage,
  meta: {
    title: '中国开放数林指数网'
  }
},
{
  path: '/paper',
  name: 'Instance',
  component: InstancePage,
  meta: {
    title: '中国开放数林指数网'
  }
},
{
  path: '/instanceDetail',
  name: 'InstanceDetail',
  component: () =>
            import('@/pages/InstanceDetail'),
  meta: {
    title: '中国开放数林指数网'
  }
},
{
  path: '/policy',
  name: 'Policy',
  component: PoliciesPage,
  meta: {
    title: '中国开放数林指数网'
  }
},
{
  path: '/policiesDetail',
  name: 'PoliciesDetail',
  component: () =>
            import('@/pages/PoliciesDetail'),
  meta: {
    title: '中国开放数林指数网'
  }
},
{
  path: '/admin',
  name: 'Admin',
  component: AdminPage,
  meta: {
    title: '中国开放数林指数网'
  }
},
{
  path: '/interface',
  name: 'Interface',
  component: ProductPage,
  meta: {
    title: '中国开放数林指数网'
  }
},
{
  path: '/feedback',
  name: 'Feedback',
  component: AlliancePage,
  meta: {
    title: '中国开放数林指数网'
  }
},
{
  path: '/about',
  name: 'AboutUs',
  component: AboutPage,
  meta: {
    title: '中国开放数林指数网'
  }
},
{
  path: '/detail',
  name: 'Detail',
  component: DetailPage,
  meta: {
    title: '中国开放数林指数网'
  }
},
{
  path: '/case',
  name: 'Case',
  component: CasePage,
  meta: {
    title: '中国开放数林指数网'
  }
},
{
  path: '/ban',
  name: 'Ban',
  component: () => import('@/pages/ban/ban'),
  meta: {
    title: '中国开放数林指数网'
  }
}
]

export default routes



// WEBPACK FOOTER //
// ./src/router/routes.js